// @flow
import React from 'react';
import { track } from '../../helpers/Tracking/Analytics';

type Props = {
  children: any,
  isFooter?: boolean
};

const ZendeskLink = ({ children, isFooter }: Props) => {
  return (
    <a
      onClick={() => {
        const eventName = isFooter ? 'click:web-footer:help' : 'click:nav:help';

        track(eventName, {
          page: window.location.pathname.toLowerCase()
        });
      }}
      href="https://help.justpark.com"
    >
      {children}
    </a>
  );
};

ZendeskLink.defaultProps = {
  isFooter: false
};

export default ZendeskLink;
